import React from "react";
import PreviewPopoverLink from "../PreviewPopover/PreviewPopoverLink";
import numeral from "numeral";

export default class RoomTypePriceTimeline extends React.Component {
  constructor(props) {
    super(props);

    this.heatMapColors = [
      "#336633",
      "#339933",
      "#33CC33",
      "#FFCC00",
      "#FF6600",
      "#FF3300",
      "#CC0000",
    ];
  }

  render() {
    console.log("this.props", this.props);
    var timeline = [];

    var current_final_price = this.props.room_type_price;

    timeline.push({
      id: "base_price",
      type: "base_price",
      name: this.props.day_of_week,
      path: this.props.base_price_path,
      previewPopover: false,
      details: this.renderDetails(
        this.props.room_type_price,
        this.props.base_minimum_stay
      ),
    });

    if (this.props.seasonal_price) {
      current_final_price =
        this.props.seasonal_price[
        `${this.props.day_of_week.toLowerCase()}_amount`
        ];
      timeline.push({
        name: this.props.season_name,
        id: this.props.season_id,
        path: this.props.season_path,
        previewPopover: false,
        type: "season",
        details: this.renderDetails(
          this.props.seasonal_price[
          `${this.props.day_of_week.toLowerCase()}_amount`
          ],
          this.props.seasonal_price[
          `${this.props.day_of_week.toLowerCase()}_minimum_stay`
          ]
        ),
      });
    } else if (this.props.season_id) {
      timeline.push({
        name: this.props.season_name,
        id: this.props.season_id,
        path: this.props.season_path,
        previewPopover: false,
        type: "season",
        details: this.renderDetails(
          this.props.room_type_price,
          this.props.base_minimum_stay
        ),
      });
    }

    if (this.props.dynamic_price_id) {
      const minimum_stay =
        (this.props.seasonal_price &&
          this.props.seasonal_price[
          `${this.props.day_of_week.toLowerCase()}_minimum_stay`
          ]) ||
        this.props.base_minimum_stay;
      const dynamic_price_rule =
        this.props.dynamic_price_adjustment;
      const price_in_effect = this.props.seasonal_price
        ? this.props.seasonal_price[
        this.props.day_of_week.toLowerCase() + "_amount"
        ]
        : this.props.room_type_price;
      const final_price =
        Math.ceil(
          (dynamic_price_rule.amount
            ? dynamic_price_rule.amount + price_in_effect
            : price_in_effect +
            price_in_effect * parseFloat(dynamic_price_rule.percentage)) / 100
        ) * 100;

      current_final_price = final_price;

      timeline.push({
        name: this.props.dynamic_price_name,
        id: this.props.dynamic_price_id,
        path: this.props.dynamic_price_path,
        previewPopover: false,
        type: "dynamic_rate",
        color: this.getHeatMapColor(this.props.dynamic_price_adjustment_comparator),
        details: `<div>${this.formatCurrency(price_in_effect)} ${dynamic_price_rule.amount >= 0 ||
          parseFloat(dynamic_price_rule.percentage) >= 0
          ? "+"
          : "–"
          } ${dynamic_price_rule.amount
            ? this.formatCurrency(dynamic_price_rule.amount)
            : parseFloat(dynamic_price_rule.percentage) * 100 + "%"
          } = ${this.formatCurrency(final_price)}, ${minimum_stay} ${minimum_stay == 1 ? I18n.t("night") : I18n.t("nights")
          }</div>`,
      });
    }

    if (this.props.is_rate && this.props.rate) {
      const { rate, rate_amount_for_date, edit_rate_path } = this.props;
      const minimum_stay =
        rate.minimum_stay ||
        (this.props.seasonal_price &&
          this.props.seasonal_price[
          `${this.props.day_of_week.toLowerCase()}_minimum_stay`
          ]) ||
        this.props.base_minimum_stay;

      timeline.push({
        name: rate.code,
        id: rate.id,
        type: "rate",
        path: edit_rate_path.replace(/\:id/, rate.id),
        previewPopover: false,
        details: `<div>${this.formatCurrency(current_final_price)} ${(!isNaN(parseInt(rate.amount)) && rate.amount >= 0) ||
          parseFloat(rate.percentage) >= 0
          ? "+"
          : "–"
          } ${rate.amount
            ? this.formatCurrency(Math.abs(rate.amount))
            : parseFloat(Math.abs(rate.percentage)) * 100 + "%"
          } = ${this.formatCurrency(rate_amount_for_date)}, ${minimum_stay} ${minimum_stay == 1 ? I18n.t("night") : I18n.t("nights")
          }</div>`,
      });
    }

    if (this.props.daily_rate) {
      timeline.push({
        name: I18n.t("daily_rate"),
        id: this.props.daily_rate.id,
        type: "daily_rate",
        previewPopover: false,
        details: this.renderDetails(
          this.props.daily_rate.amount,
          this.props.daily_rate.minimum_stay
        ),
      });
    }

    var timelineEvents = timeline.map((event) => {
      return (
        <li key={event.id} className="event" data-event={I18n.t(event.type)}>
          <div className="event-date">
            <div className="date">
              {event.color ? (
                <div
                  style={{
                    background: event.color,
                    width: "18px",
                    height: "18px",
                    display: "inline-block",
                    margin: "0 7px 0 0",
                    position: "relative",
                    top: "4px",
                  }}
                ></div>
              ) : null}
              {event.previewPopover === false ? (
                <a
                  href={event.path}
                  className="modal-iframe"
                  data-fullscreen="true"
                  style={{ pointerEvents: event.path ? "auto" : "none" }}
                >
                  {event.name}
                </a>
              ) : (
                <PreviewPopoverLink
                  model_type={
                    event.type === "dynamic_price"
                      ? "dynamic_price"
                      : event.type
                  }
                  model_id={event.id}
                  text={event.name}
                />
              )}
              {event.details ? (
                <div
                  className="details"
                  dangerouslySetInnerHTML={{ __html: event.details }}
                />
              ) : null}
            </div>
          </div>
        </li>
      );
    });

    if (timelineEvents && timelineEvents.length > 0) {
      return (
        <div className="panel panel-default" style={{ margin: "0 0 20px 0" }}>
          <div className="panel-body" style={{ padding: 0 }}>
            <ul className="timeline">{timelineEvents}</ul>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  renderDetails(price, minimum_stay) {
    var details = "";
    details += `${this.formatCurrency(price)}`;
    if (Number.isInteger(minimum_stay)) {
      details += `, ${minimum_stay} ${minimum_stay == 1 ? I18n.t("night") : I18n.t("nights")
        }`;
    }
    return details;
  }

  formatCurrency(num) {
    return (
      I18n.t("number.currency.format.unit") +
      numeral(num / 100).format(
        "0" + I18n.t("number.currency.format.delimiter") + "0"
      )
    );
  }

  getHeatMapColor(comparatorName) {
    switch (comparatorName) {
      // PACE — ahead (first 3 colors)
      case 'very_ahead_of_pace':
        return this.heatMapColors[0];
      case 'ahead_of_pace':
        return this.heatMapColors[1];
      case 'slightly_ahead_of_pace':
        return this.heatMapColors[2];
  
      // PACE — behind (last 3 colors)
      case 'slightly_behind_pace':
        return this.heatMapColors[4];
      case 'behind_pace':
        return this.heatMapColors[5];
      case 'very_behind_pace':
        return this.heatMapColors[6];
  
      // OCCUPANCY — greater/less
      case 'greater_than':
      case 'greater_than_or_equal_to':
        return this.heatMapColors[0];
      case 'less_than':
      case 'less_than_or_equal_to':
        return this.heatMapColors[6];
      case 'equal_to':
        return this.heatMapColors[3];
  
      // Default
      default:
        return this.heatMapColors[3];
    }
  }
  


  // getHeatMapColor(percent) {
  //   if (percent < 0) {
  //     // behind - last 3 colors
  //     var percent = Math.abs(percent);
  //     if (percent <= 33) {
  //       return this.heatMapColors[4];
  //     } else if (percent > 33 && percent <= 67) {
  //       return this.heatMapColors[5];
  //     } else {
  //       return this.heatMapColors[6];
  //     }
  //   } else if (percent > 0) {
  //     // ahead - first 3 colors
  //     if (percent <= 33) {
  //       return this.heatMapColors[2];
  //     } else if (percent > 33 && percent <= 67) {
  //       return this.heatMapColors[1];
  //     } else {
  //       return this.heatMapColors[0];
  //     }
  //   } else {
  //     // same - middle color
  //     return this.heatMapColors[3];
  //   }
  // }
}
